import React from "react";
import { createPortal } from "react-dom";

const MENU_WIDTH = 190;
const MENU_ITEM_HEIGHT = 40;
const MENU_ITEMS = 3;
const MENU_HEIGHT = MENU_ITEM_HEIGHT * MENU_ITEMS + 16;

const menuItemStyle = {
  padding: "9px 16px",
  fontSize: "13px",
  color: "#444",
  cursor: "pointer",
  transition: "background-color 0.15s ease",
};

const ClinicActionsDropdown = ({
  openDropdownId,
  dropdownPos,
  clinics,
  onAction,
}) => {
  if (!openDropdownId) return null;

  const clinic = clinics.find((c) => c.id === openDropdownId);
  if (!clinic) return null;

  const handleItemClick = (action) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    onAction(action, clinic);
  };

  return createPortal(
    <ul
      role="menu"
      aria-label="Clinic actions"
      className="clinic-actions-menu"
      onMouseDown={(e) => e.stopPropagation()}
      style={{
        position: "fixed",
        top: dropdownPos.top,
        left: dropdownPos.left,
        backgroundColor: "#ffffff",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        boxShadow: "0px 4px 16px rgba(0,0,0,0.12)",
        padding: "6px 0",
        margin: 0,
        listStyle: "none",
        zIndex: 99999,
        minWidth: `${MENU_WIDTH}px`,
        maxWidth: "min(90vw, 220px)",
      }}
    >
      <li
        role="menuitem"
        tabIndex={0}
        onClick={handleItemClick("view")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleItemClick("view")(e);
        }}
        style={{
          ...menuItemStyle,
          color: "#27B99A",
          fontWeight: "600",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#E7F3FF";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        View Clinic
      </li>

      <li
        role="menuitem"
        tabIndex={0}
        onClick={handleItemClick("edit")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") handleItemClick("edit")(e);
        }}
        style={{
          ...menuItemStyle,
          borderTop: "1px solid #f0f0f0",
          marginTop: "4px",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#F8FAFC";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        Edit Clinic
      </li>

      {clinic.status !== "Inactive" && (
        <li
          role="menuitem"
          tabIndex={0}
          onClick={handleItemClick("deactivate")}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ")
              handleItemClick("deactivate")(e);
          }}
          style={{
            ...menuItemStyle,
            color: "#EF4444",
            borderTop: "1px solid #f0f0f0",
            marginTop: "4px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#FEF2F2";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "transparent";
          }}
        >
          Deactivate Clinic
        </li>
      )}
    </ul>,
    document.body,
  );
};

export { MENU_WIDTH, MENU_HEIGHT };
export default ClinicActionsDropdown;
